import {SharedBoardsClient} from '@client/shared-boards-client'
import {sharedBoardsEvents} from '@client/shared-boards-events'
import {SharedBoardsHelper} from '@client/shared-boards-helper'
import {Tracking} from '@common/tracking'
import {Input, makeInputModel} from '@components/common/controls/input'
import {UserAvatar} from '@components/user-avatar'
import {UserName} from '@components/user-name'
import {textCursorSelectAll, useBoolean} from '@containers/hooks'
import {PageService} from '@extensions/page-service'
import * as React from 'react'
import {Lang} from 'yougile-lang'
import {isDataObjectId, sharingGuestAccount} from 'yougile-model'
import {logger, Util} from 'yougile-util'
import {TrackingEvent} from '@common/tracking-events'

export const ShareNameChanger = () => {
  const bem = Util.bemFrom('share-name-changer')
  const [wait, setWait] = React.useState(false)
  const changing = useBoolean(false)
  const model = makeInputModel()

  const isShared = SharedBoardsClient.getId()
  const {guestId} = SharedBoardsClient
  const guestName = SharedBoardsClient.getGuestInfo(guestId)?.name ?? ''

  const save = async () => {
    const newName = model.get()
    logger.log(newName)
    changing.turnOff()
    setWait(true)
    await SharedBoardsClient.changeGuest({name: newName})
    await SharedBoardsHelper.updateGustsInfo(PageService.getCurrentBoard()?.id)
    Tracking.send(TrackingEvent.shareChangeName)
    setWait(false)
    sharedBoardsEvents.trigger()
  }

  if (!isShared) {
    return null
  }
  if (wait) {
    return (
      <div className={bem()}>
        <div className={bem('wait')} />
      </div>
    )
  }
  return (
    <div className={bem()}>
      <div className={bem('you')}>{Lang.msg.you}:</div>
      <div className={bem('user')}>
        <UserAvatar
          size={24}
          userId={sharingGuestAccount.id}
          guestId={guestId}
        />
        {!changing.value ? (
          <UserName userId={sharingGuestAccount.id} guestId={guestId} />
        ) : (
          <Input
            model={model}
            onEnter={save}
            onEscape={changing.turnOff}
            defaultValue={guestName}
            onFocus={textCursorSelectAll}
          />
        )}
      </div>
      {!isDataObjectId(guestId) && (
        <>
          {!changing.value ? (
            <div className={bem('change-btn')} onClick={changing.turnOn}>
              {Lang.msg.changeName}
            </div>
          ) : (
            <div className={bem('save')} onClick={save}>
              {Lang.msg.save}
            </div>
          )}
        </>
      )}
    </div>
  )
}
